import React from 'react';
import { Phone, Calendar } from 'lucide-react';
import { CLINIC_CONFIG } from '../utils/whatsapp';
import { SpecialistAvatar } from './SpecialistAvatar';

interface StickyMobileBarProps {
  onOpenCalculator: () => void;
}

export const StickyMobileBar: React.FC<StickyMobileBarProps> = ({ onOpenCalculator }) => {
  return (
    <div
      id="sticky-mobile-actions"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-md border-t border-slate-200 p-2 px-3 shadow-xl flex items-center gap-2"
    >
      {/* Call button */}
      <a
        id="mobile-sticky-call"
        href={`tel:${CLINIC_CONFIG.landlineRaw}`}
        className="flex-1 py-2.5 rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-800 border border-slate-300 font-bold text-xs flex items-center justify-center gap-1.5 transition-colors"
        title="Klinik Sabit Hattını Ara"
      >
        <Phone className="w-3.5 h-3.5 text-amber-600" />
        <span>Ara</span>
      </a>

      {/* Main Live Chat Consultation Action with Specialist Avatar */}
      <button
        type="button"
        id="mobile-sticky-livechat"
        onClick={() => {
          if (typeof window !== 'undefined' && window.openLiveChat) {
            window.openLiveChat();
          } else if (typeof window !== 'undefined') {
            window.dispatchEvent(new CustomEvent('open-live-chat'));
          }
        }}
        className="flex-[2] py-2 px-3 rounded-xl bg-slate-900 hover:bg-slate-800 text-white font-bold text-xs flex items-center justify-center gap-2 shadow-sm border border-amber-500/50 active:scale-95 transition-all cursor-pointer group"
      >
        <SpecialistAvatar size="xs" showOnlineStatus={true} bordered={false} />
        <span className="truncate group-hover:text-amber-300 transition-colors">Uzmana Danışın</span>
        <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse shrink-0" />
      </button>

      {/* Appointment / Zone plan shortcut */}
      <a
        id="mobile-sticky-calc"
        href="#fiyat-hesapla"
        onClick={onOpenCalculator}
        className="p-2.5 rounded-xl bg-slate-100 border border-slate-300 text-amber-700 flex items-center justify-center hover:bg-slate-200"
        aria-label="Randevu & Bölge Planı"
        title="Randevu & Bölge Planı"
      >
        <Calendar className="w-4 h-4" />
      </a>
    </div>
  );
};
